<template>
    <el-container style="height: 100%">
        <el-main style="height: 100%">
            <!-- 顶部：切换数据视图 -->
            <div class="dv-toolbar">
                <!-- 下拉宽度：桌面 320px，窄屏自动收缩到 100% -->
                <el-select v-model="currentId" placeholder="请选择数据视图" class="dv-select">
                    <el-option v-for="dv in list" :key="dv.id" :label="dv.name" :value="dv.id" />
                </el-select>
            </div>

            <el-empty v-if="!currentView" description="暂无可查看的数据视图" />

            <template v-else>
                <!-- 区块：标题分割，区块内卡片一行三个 -->
                <div v-for="(section, sIdx) in (currentView.sections || [])" :key="currentView.id + '-section-' + sIdx" class="dv-section">
                    <div class="dv-section-title">{{ section.name || '未命名区块' }}</div>
                    <el-row :gutter="12">
                        <!-- 卡片列响应式（Element Plus 断点）：
                             xs <768px   手机：1列(24)
                             sm ≥768px   小平板：2列(12)
                             md ≥992px   平板/笔记本：3列(8)
                             lg ≥1200px  桌面：3列(8)
                             xl ≥1920px  大屏：3列(8)
                             调整每行卡片数时改对应 span 值即可 -->
                        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8"
                            v-for="(card, cIdx) in (section.cards || [])"
                            :key="currentView.id + '-card-' + sIdx + '-' + cIdx"
                            style="margin-bottom: 12px">
                            <component :is="cardComponent(card.type)" :card="card"
                                :view-id="currentView.id"
                                :section-index="sIdx"
                                :card-index="cIdx" />
                        </el-col>
                    </el-row>
                </div>
            </template>
        </el-main>
    </el-container>
</template>

<script>
import request from '@/utils/request';
import CardChartBar from './components/CardChartBar.vue';
import CardChartColumn from './components/CardChartColumn.vue';
import CardChartLine from './components/CardChartLine.vue';
import CardChartPie from './components/CardChartPie.vue';
import CardTable from './components/CardTable.vue';
import CardText from './components/CardText.vue';

export default {
    name: 'DataView',
    components: { CardChartBar, CardChartColumn, CardChartLine, CardChartPie, CardTable, CardText },
    data() {
        return {
            list: [],
            currentId: '',
            storageKey: 'hidoc_dataview_current_id'
        };
    },
    computed: {
        currentView() {
            return this.list.find(x => x.id === this.currentId) || null;
        }
    },
    watch: {
        currentId(val) {
            if (val) {
                localStorage.setItem(this.storageKey, val);
            }
        }
    },
    mounted() {
        document.title = 'Hidoc-图览';
        this.loadList();
    },
    methods: {
        loadList() {
            return request({
                url: '/dataview/viewList',
                method: 'post',
                data: {}
            }).then(res => {
                if (res.code === 0) {
                    this.list = res.meta.dataViews || [];
                    // 优先从缓存恢复上次查看的数据视图，否则默认选第一个
                    const cachedId = localStorage.getItem(this.storageKey);
                    if (cachedId && this.list.some(x => x.id === cachedId)) {
                        this.currentId = cachedId;
                    } else if (this.list.length > 0) {
                        this.currentId = this.list[0].id;
                    }
                }
            });
        },
        cardComponent(type) {
            const map = {
                'card-chart-bar': 'CardChartBar',
                'card-chart-column': 'CardChartColumn',
                'card-chart-line': 'CardChartLine',
                'card-chart-pie': 'CardChartPie',
                'card-table': 'CardTable',
                'card-text': 'CardText'
            };
            return map[type] || 'CardText';
        }
    }
};
</script>

<style scoped>
.el-main {
    text-align: left;
}
.dv-toolbar {
    margin-bottom: 12px;
}
.dv-select {
    width: 320px;    /* 桌面默认宽度 */
    max-width: 100%; /* 手机窄屏不超过容器宽度 */
}
.dv-section {
    margin-bottom: 20px;
}
.dv-section-title {
    font-size: 16px;
    font-weight: bold;
    padding: 8px 12px;
    margin-bottom: 12px;
    border-left: 4px solid #409eff;
    background: #f5f7fa;
    color: #303133;
}

/* 移动端微调（断点与 el-col 的 xs 一致，<768px） */
@media (max-width: 768px) {
    .dv-toolbar {
        margin-bottom: 10px;
    }
    .dv-section-title {
        font-size: 14px;
        padding: 6px 10px;
    }
    /* iOS 聚焦输入框字号小于 16px 会自动放大页面，这里固定 16px 避免缩放 */
    .dv-select :deep(.el-select__input),
    .dv-select :deep(.el-select__placeholder),
    .dv-select :deep(.el-select__selected-item) {
        font-size: 16px;
    }
}
</style>
